/** @format */

import { AfterViewInit, Directive, ElementRef, inject, OnDestroy, output } from '@angular/core';
import { InViewportParentDirective } from '../in-viewport-parent/in-viewport-parent.directive';

/**
 * Directive that uses the IntersectionObserver API to observe when an element enters or leaves the
 * viewport. Requires {@link InViewportParentDirective} on a parent element.
 */
@Directive({
  selector: '[sharedUtilsDirectiveInViewport]',
})
export class InViewportDirective implements AfterViewInit, OnDestroy {
  private readonly parentDirective = inject(InViewportParentDirective);
  private readonly elementRef = inject(ElementRef);

  readonly inViewport = output<boolean>();

  ngAfterViewInit() {
    this.parentDirective.add(this.elementRef.nativeElement, (inViewport: boolean) => {
      this.inViewport.emit(inViewport);
    });
  }

  ngOnDestroy() {
    this.parentDirective.remove(this.elementRef.nativeElement);
  }
}
